<app-settings-search-bar [formControl]="searchControl"></app-settings-search-bar>

<app-dashboard-view-ordering [(ordering)]="ordering"></app-dashboard-view-ordering>

<ng-container *ngFor="let device of devices$ | async | filterKey:searchControl.value:'name':'groupName':'health_idx' | orderByKey:ordering">
  <app-dashboard-view-device-row [device]="device"></app-dashboard-view-device-row>
</ng-container>
